import { useContext } from "react";

import { check_small } from "../../constant";
import { StateContext } from "../../context/globalContext/context";
import { iGlobalContext } from "../../context/globalContext/interface";
import { isPartnerBranding } from "../../utils/partnerBranding";

type Props = {
  className?: string;
  size?: number;
  alt?: string;
};

function BrandCheckCircleIcon({ className = "", size = 16, alt = "" }: Props): JSX.Element {
  const { branding }: iGlobalContext = useContext(StateContext);

  if (!isPartnerBranding(branding)) {
    return <img src={check_small} alt={alt} className={className} />;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect width="16" height="16" rx="8" fill="var(--primary-main)" />
      <path
        d="M11.1835 4.93701C11.3254 4.93705 11.4517 4.99025 11.5634 5.09912C11.6749 5.21081 11.7303 5.33779 11.7303 5.48096C11.7303 5.62426 11.675 5.752 11.5634 5.86377L7.05066 10.3804C6.94192 10.489 6.81434 10.5424 6.66687 10.5425C6.51921 10.5425 6.39094 10.4892 6.2821 10.3804L4.4325 8.52979H4.43152C4.32304 8.41827 4.27039 8.29107 4.27039 8.14795C4.27039 8.04039 4.30053 7.94172 4.36316 7.85205L4.4364 7.76611C4.54801 7.65718 4.67491 7.60313 4.81824 7.60303C4.96174 7.60303 5.08933 7.65706 5.20105 7.76611L6.64929 9.21826L6.66687 9.23584L10.8036 5.09912L10.8026 5.09814C10.9143 4.98933 11.0415 4.93701 11.1835 4.93701Z"
        fill="white"
        stroke="black"
        strokeWidth="0.05"
      />
    </svg>
  );
}

export default BrandCheckCircleIcon;
